import { useCallback } from 'react';
import { Node as SlateNode, Editor, Range } from 'slate';
import { ReactEditor } from 'slate-react';
import { serializeToPlainText } from '../serialize';
/**
 * Check if a value is a DOM node.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isDOMNode = (value) => {
    return value instanceof Node;
};
/**
 * Check if the target is editable and in the editor.
 */
const hasEditableTarget = (editor, target) => {
    return (isDOMNode(target) &&
        ReactEditor.hasDOMNode(editor, target, { editable: true }));
};
export const useOnCopy = (editor) => {
    const onCopy = useCallback((e) => {
        if (!hasEditableTarget(editor, e.target)) {
            return;
        }
        const selection = editor.selection;
        if (selection == null) {
            return;
        }
        e.preventDefault();
        const fragment = SlateNode.fragment(editor, selection);
        e.clipboardData.setData('text/plain', serializeToPlainText(fragment));
    }, [editor]);
    return onCopy;
};
export const useOnCut = (editor) => {
    const onCut = useCallback((e) => {
        if (!hasEditableTarget(editor, e.target)) {
            return;
        }
        const selection = editor.selection;
        if (selection == null) {
            return;
        }
        e.preventDefault();
        const fragment = SlateNode.fragment(editor, selection);
        e.clipboardData.setData('text/plain', serializeToPlainText(fragment));
        if (!ReactEditor.isReadOnly(editor) && Range.isExpanded(selection)) {
            Editor.deleteFragment(editor);
        }
    }, [editor]);
    return onCut;
};
//# sourceMappingURL=onCopyCut.js.map